var _rect, _g, _path, _path2, _path3, _path4, _rect2, _g2, _g3, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 678,
    viewBox: "0 0 430 678",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    clipPath: "url(#clip0_175_1046)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 768,
    transform: "matrix(-5.98511e-08 -1 -1 3.1924e-08 599 520)",
    fill: "#131126"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_175_1046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.42 872.004C613.925 737.334 665.595 490.29 612.83 320.216L443.111 -226.827C390.346 -396.901 253.125 -425.602 136.621 -290.932L-42.7112 -83.6377C-159.216 51.0324 -210.887 298.076 -158.121 468.15L11.5978 1015.19C64.363 1185.27 201.583 1213.97 318.088 1079.3L497.42 872.004Z",
    fill: "url(#paint0_radial_175_1046)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    filter: "url(#filter1_f_175_1046)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.191 1156.81C306.2 1234.86 414.33 1192.09 439.706 1061.26L582.561 324.768C607.937 193.945 540.949 24.6143 432.94 -53.442L198.383 -222.952C90.3742 -301.008 -17.7555 -258.232 -43.1311 -127.409L-185.987 609.085C-211.362 739.908 -144.375 909.239 -36.3655 987.295L198.191 1156.81Z",
    fill: "url(#paint1_radial_175_1046)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    filter: "url(#filter2_f_175_1046)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M395.964 1107.1C503.973 1185.16 612.103 1142.38 637.478 1011.56L746.082 451.649C771.457 320.826 704.47 151.495 596.461 73.4388L453.198 -30.0948C345.189 -108.151 237.059 -65.3748 211.684 65.4488L103.08 625.356C77.7044 756.18 144.692 925.51 252.701 1003.57L395.964 1107.1Z",
    fill: "url(#paint2_radial_175_1046)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    filter: "url(#filter3_f_175_1046)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-83.5097 1067.3C55.3882 1167.68 194.441 1112.67 227.074 944.435L297.615 580.759C330.248 412.521 244.103 194.765 105.205 94.3857C-33.6934 -5.99341 -172.746 49.0164 -205.379 217.253L-275.92 580.93C-308.553 749.167 -222.408 966.924 -83.5097 1067.3Z",
    fill: "url(#paint3_radial_175_1046)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter4_f_175_1046)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M312.338 960.104C210.759 1136.75 182.316 1332.97 180.792 1408.99C184.4 1562.94 196.921 1801.27 218.133 1523.01C244.648 1175.19 342.795 1115.75 518.343 800.785C658.782 548.811 587.301 488.958 534.006 490.528L441.053 584.256C440.473 635.935 413.918 783.455 312.338 960.104Z",
    fill: "url(#paint4_radial_175_1046)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 140,
    width: 480,
    height: 380,
    fill: "url(#paint5_linear_175_1046)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_175_1046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.164 194.233C442.544 208.13 452.664 240.782 438.764 267.162C424.864 293.542 392.215 303.662 365.837 289.765C339.456 275.868 329.336 243.218 343.233 216.837C357.13 190.456 389.782 180.336 416.164 194.233Z",
    fill: "url(#paint6_radial_175_1046)",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_175_1046)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 164.5,
    r: 37.5,
    fill: "url(#paint7_radial_175_1046)",
    fillOpacity: 0.6
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.511 506.784C311.076 594.033 250.805 670.458 169.89 677.481C88.9736 684.504 18.056 619.467 11.4893 532.217C4.92385 444.966 65.1949 368.543 146.11 361.519C227.026 354.497 297.944 419.534 304.511 506.784Z",
    fill: "url(#paint8_radial_175_1046)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_175_1046",
    x: -313.929,
    y: -510.922,
    width: 1082.57,
    height: 1810.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67.5618,
    result: "effect1_foregroundBlur_175_1046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_175_1046",
    x: -312.003,
    y: -382.6,
    width: 1020.58,
    height: 1699.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.323,
    result: "effect1_foregroundBlur_175_1046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_175_1046",
    x: -22.9362,
    y: -189.743,
    width: 895.034,
    height: 1456.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.323,
    result: "effect1_foregroundBlur_175_1046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_175_1046",
    x: -403.472,
    y: -76.4162,
    width: 828.639,
    height: 1314.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.323,
    result: "effect1_foregroundBlur_175_1046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_175_1046",
    x: 131.792,
    y: 441.498,
    width: 517.464,
    height: 1258.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.5,
    result: "effect1_foregroundBlur_175_1046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_175_1046",
    x: 333,
    y: 188,
    width: 115.999,
    height: 115.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_175_1046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_175_1046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_175_1046",
    x: 37,
    y: 117,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_175_1046"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_175_1046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.197 518.544) rotate(-127.306) scale(499.572 519.033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AEA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39CABB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_175_1046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(375.697 374.362) rotate(135.795) scale(386.928 482.245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484EB7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_175_1046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(576.105 459.444) rotate(135.795) scale(330.472 411.881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DAAAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484EB7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_175_1046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-61.8112 748.161) rotate(-117.127) scale(392.215 319.013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F257A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_175_1046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(435.902 817.377) rotate(108.585) scale(415.098 231.997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484EB7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_175_1046",
    x1: 215,
    y1: 140,
    x2: 215,
    y2: 520,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_175_1046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(433.784 229.751) rotate(163.847) scale(106.234 96.5434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6151C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#A14BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "#CBCAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_175_1046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.1875 121.687) rotate(87.7365) scale(79.1243 932.119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B6471"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_175_1046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.603 358.351) rotate(115.632) scale(368.067 351.935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#FF6F6F",
    stopOpacity: 0.536826
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550999,
    stopColor: "#D427FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_1046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 768,
    fill: "white",
    transform: "matrix(-5.98511e-08 -1 -1 3.1924e-08 599 520)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMainMobile);
export default __webpack_public_path__ + "static/media/backgroundMainMobile.83c52cfeb51c35a3d17ae11961331009.svg";
export { ForwardRef as ReactComponent };